import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { EntityImport_ModuleContextService } from './EntityImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class EntityImport_entity_import_total_completed_by_date_widget_ComponentContextService {
  private readonly moduleContext: EntityImport_ModuleContextService;

  constructor(moduleContext: EntityImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'entity_import_total_completed_by_date_widget',
      type: ComponentType.widget
    }
  }
}